export default "__VITE_ASSET__p3Ai$tQD__"